import React, { ButtonHTMLAttributes, forwardRef } from 'react';

import { FontIcons } from '@components/library/icon';
import BaseButton from '../BaseButton';
import styleClassNames from './styles.module.scss';

interface TertiaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: string | FontIcons;
  iconSize?: number;
  isLoading?: boolean;
  loadingCopy?: string;
  loadingIcon?: string | FontIcons;
  loadingIconSize?: number;
  size?: ButtonSize;
}

type ButtonSize = 'xsmall' | 'small' | 'medium' | 'large';

const TertiaryButton = forwardRef<HTMLButtonElement, TertiaryButtonProps>((props, ref) => {
  const baseProps = {
    ...props,
    styleClassNames,
    variantName: 'tertiary',
  };

  return <BaseButton {...baseProps} ref={ref} />;
});

export default TertiaryButton;
